import { Col } from "reactstrap";
import JobInterestIcon from "../../assets/job_registration/Views.png";
import LocationIcon from "../../assets/job_registration/Location.png";
import ExperienceIcon from "../../assets/job_registration/Experience.png";

const JobHighlights = ({job}) => {
    return (
        <div id="highlights">
            <Col>
                <div style={{display:"flex", marginBottom: 10}}>
                    <img style={{width:30, height:30}} src= {LocationIcon} alt={LocationIcon}/>
                    <div style={{margin:"auto", marginLeft: 5}}>{job?.job_details? `${job?.job_details[0]?.location ?? "-"}` : `${job?.job_location ?? "-"}`}</div>
                </div>
                <div style={{display:"flex", marginBottom: 10}}>
                    <img style={{width:30, height:30}} src= {ExperienceIcon} alt={ExperienceIcon}/>
                    <div style={{margin:"auto", marginLeft: 5}}>{job?.job_experience ?? "-"}</div>
                </div>
                <div style={{display:"flex", marginBottom: 10}}>
                    <img style={{width:30, height:30}} src= {JobInterestIcon} alt={JobInterestIcon}/>
                    <div style={{margin:"auto", marginLeft: 5, color: "grey"}}>{`${job?.total_interest ?? 0} Applied`}</div>
                </div>
            </Col>
        </div>
    )
}

export default JobHighlights;